import { initGraphQLTada } from 'gql.tada';
import merge from 'lodash/merge';
export var graphql = initGraphQLTada();
export { initGraphQLTada, readFragment, maskFragments, unsafe_readResult } from 'gql.tada';
// declare function maskNestedFragments<const Fragments extends readonly FragmentShape[], Shape = resultOfFragmentsRec<Fragments>>(
//   _fragments: Fragments,
//   children: Pick<Shape, $tada.fragmentRefs>,
//   fragment: Omit<Shape, $tada.fragmentRefs>,
// ): fragmentRefsOfFragmentsRec<Fragments> {}
export var maskNestedFragments = function(_fragments, children, fragment) {
    return merge({}, children, fragment); // eslint-disable-line
};
export function mergeFragments(a, b, c, d, e, f, g, h) {
    return merge(a, b, c, d, e, f, g, h); // eslint-disable-line
}
